export default __webpack_public_path__ + "static/soda3-e01a131cb3a69171c3c86851c968ee2d.png";